import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const StepResources = Resources.Onboarding.Steps.PersonalInformation;

export const getPersonalInformationValidationSchema = (t: TFunction) =>
  z.object({
    isUserConfirmed: z.boolean().refine((value) => value, {
      error: t(StepResources.ConfirmDataRequest),
    }),
    isIDCardApprovedByClient: z.boolean({
      error: t(Resources.PersonalInfo.DataConfirmationMessage),
    }),
    // ZS-1624: the Stardust consent checkbox — present only when the form shows it (the customer
    // flow), absent (undefined) in the business-entity flow.
    isStardustParticipant: z.boolean().optional(),
    // ZS-1623: the Díky Tobě consent checkbox — the same shape as the Stardust one.
    isThanksToYouParticipant: z.boolean().optional(),
  });

export type PersonalInformationConfirmationFormModel = z.infer<
  ReturnType<typeof getPersonalInformationValidationSchema>
>;
